<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">
          <span>课时统计</span>

        </div>
        <div class="searcharea">
          <button type="button" class="btn btn-default btn_option"
                  style="height: 25px;line-height: 10px;float: right;margin-top:5px;"
                  @click="exportCourseStatistics()">导出</button>
        </div>
      </div>
      <div class="body_content class_body_content">
        <div class="class_body_content_self">
          <!--课时统计列表-->
          <table class="table table-striped table-bordered table_classStatistics">
            <thead>
            <tr>
              <th width="5%">#</th>
              <th width="20%">姓名</th>
              <th width="20%">课时</th>
              <th width="20%">课数</th>
              <th width="10%">查看详情</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(courseStatisticsOne, index) in courseStatisticsList" :key="index">
              <td width="5%">
                {{index+1}}
              </td>
              <td width="20%">{{courseStatisticsOne.teacherName}}</td>
              <td width="20%">{{courseStatisticsOne.takeHours}}</td>
              <td width="20%">{{courseStatisticsOne.counts}}</td>
              <td width="10%">
                <div class="details_pic" data-toggle="modal" data-target="#myModal" @click="initCourseDetailsList(courseStatisticsOne.teacherId,courseStatisticsOne.teacherName)"></div>
              </td>
            </tr>
            </tbody>
          </table>
          <!--查看课时详情模态框（已结业）-->
          <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog dialog-work">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">{{courseStatisticsInfo.teacherName}}</h4>
                </div>
                <div class="modal-body modal_work_details">
                  <!--<button type="button" class="btn btn-default btn_option"
                          style="margin-bottom: 5px"
                          @click="showAddModal()">新增课时</button>-->
                  <table class="table table-bordered table-striped table_details">
                    <thead>
                    <tr>
                      <th width="10%">日期</th>
                      <th width="10%">时间</th>
                      <th width="15%">教学内容</th>
                      <th width="10%">上课地点</th>
                      <th width="10%">课时</th>
                      <th width="10%">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(courseDetailsOne, index) in courseDetailsList" :key="index">
                      <td width="10%">{{courseDetailsOne.startDate}}</td>
                      <td width="10%">{{courseDetailsOne.time}}</td>
                      <td width="15%">{{courseDetailsOne.lessonName}}</td>
                      <td width="10%">{{courseDetailsOne.roomName}}</td>
                      <td width="10%">{{courseDetailsOne.takeHours}}</td>
                      <td width="10%">
                        <div class="edit_pic" data-toggle="modal" data-target="#myModal_update" @click="show_edit(index)"></div>
                        <div class="delete_pic" @click="deleteCourseDetails(courseDetailsOne.id)"></div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!--修改课时模态框-->
          <div class="modal fade" id="myModal_update" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_update" aria-hidden="true">
            <div class="modal-dialog dialog-work">
              <div class="modal-content modal-content-update">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel_update">修改课时</h4>
                </div>
                <div class="modal-body modal_work_details">
                  <input type="number" min="0" max="100" v-validate="'numeric'" data-vv-scope="updateCourse" data-vv-as="课时" name="takeHours" class="form-control modelInput" v-model="courseStatisticsInfo.takeHours">
                  <span class="validateTip validateTip_unit">{{ errors.first('updateCourse.takeHours') }}</span>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default btn_save" @click="updateClassHour()">保存</button>
                  <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">取消</button>
                </div>
              </div>
            </div>
          </div>


          <!--新增课时模态框-->
          <div class="modal fade" id="myModal_add" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_add" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_add">
                    新增课时
                  </h4>
                </div>
                <div class="modal-body">
                  <div class="trainingSchedule_form">
                    <!--选择日期-->
                    <div>
                      <label>选择日期：</label>
                      <input v-validate="'required|date_format:yyyy-MM-dd'" data-vv-scope="course" data-vv-as="日期" class="form-control scheduleInfo" size="16" type="text" placeholder="选择日期" name="new_lesson_Date" id="chooseStartDate" readonly v-model="courseInfo.startDate" autocomplete="off"/>
                      <span class="spanRed">*</span>
                      <span class="validateTip">{{ errors.first('course.new_lesson_Date') }}</span>
                    </div>

                    <!--时间-->
                    <div>
                      <label>选择时间：</label>
                      <input v-validate="'required'" data-vv-scope="course" data-vv-as="时间" name="time" class="form-control scheduleInfo" type="text" placeholder="输入培训时间" v-model="courseInfo.time" @click="showTimeDiv()" autocomplete="off">
                      <div id="time_div">
                        <option v-for="(les_time,index) in lesson_time" :key="index" :value="les_time"
                                @click="putTimeData(index)">{{les_time}}</option>
                        <option value="" @click="putTimeData(-1)">自定义</option>
                      </div>
                      <span class="spanRed">*</span>
                      <span class="validateTip">{{ errors.first('course.time') }}</span>
                    </div>

                    <!--教学内容-->
                    <div>
                      <label>教学内容：</label>
                      <input v-validate="'required'" data-vv-scope="course" data-vv-as="教学内容" name="name" class="form-control scheduleInfo" type="text" placeholder="输入教学内容" v-model="courseInfo.lessonName" autocomplete="off">
                      <span class="spanRed">*</span>
                      <span class="validateTip">{{ errors.first('course.name') }}</span>
                    </div>

                    <!--上课地点-->
                    <div>
                      <label>上课地点：</label>
                      <input v-validate="'required'" data-vv-scope="course" data-vv-as="上课地点" readonly name="roomName" class="form-control scheduleInfo" type="text" placeholder="选择上课地点" v-model="courseInfo.roomName" @click="room_step='place';isShowRoomDiv = true" autocomplete="off">
                      <span class="spanRed">*</span>
                      <div class="room_div" :class="{isShowRoomDivClass: isShowRoomDiv}">
                        <ul id="myTab" class="nav nav-tabs">
                          <li v-for="(place, index_p) in placeList" :key="index_p" @click="placeId=place.id,selectPlace(index_p)" :class="{havenClick: place.id == placeId}">
                            {{place.name}}
                          </li>
                        </ul>
                        <div id="myTabContent" class="tab-content">
                          <ul id="myTab_" class="nav nav-tabs">
                            <li v-for="(rooms, index_r) in roomsList" :key="index_r" @click="roomId=rooms.id,selectRooms(index_r)" :class="{havenClick: rooms.id == roomId}">
                              {{rooms.name}}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <span class="validateTip">{{ errors.first('course.roomName') }}</span>
                    </div>

                    <!--课时-->
                    <div>
                      <label>课时：</label>
                      <input v-validate="'required'" data-vv-scope="course" data-vv-as="教学课时" name="hours" class="form-control scheduleInfo" type="text" placeholder="输入课时" v-model="courseInfo.takeHours" style="margin-left: 28px" autocomplete="off">
                      <span class="spanRed">*</span>
                      <span class="validateTip">{{ errors.first('course.hours') }}</span>
                    </div>

                  </div>

                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default btn_save" @click="addCourseHours()">确定</button>
                  <button type="button" class="btn btn-default btn_cancel" @click="cancelSaveData()">取消</button>
                </div>
              </div>
            </div>
          </div>

          <!-- 模态框（Modal） -->
          <div class="modal fade" id="myModal_time" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_time" aria-hidden="true">
            <div class="modal-dialog time_dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel_time">培训时间</h4>
                </div>
                <div class="modal-body">
                  <div style="margin: 10px 0">
                    <label>开始时间：</label>
                    <input type='time' v-validate="'required'" data-vv-scope="selfTime" data-vv-as="开始时间" name="startTime" class="form-control" style="width: 78%" placeholder="开始时间" v-model="selfTime.startTime"/>
                    <span class="validateTip">{{ errors.first('selfTime.startTime') }}</span>
                  </div>
                  <div style="margin: 10px 0">
                    <label>结束时间：</label>
                    <input type='time' v-validate="'required'" data-vv-scope="selfTime" data-vv-as="开始时间" name="endTime" class="form-control" style="width: 78%" placeholder="结束时间" v-model="selfTime.endTime"/>
                    <span class="validateTip">{{ errors.first('selfTime.endTime') }}</span>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn" @click="chooseTimeOk()">确定</button>
                  <button type="button" class="btn" data-dismiss="modal">返回</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';
  import dictionaryData from '../json/dictionary';

  export default {
    name: "courseStatistics",
    data() {
      return {
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,

        userCode: this.$store.state.userCode,
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,

        //今日日期
        timeDate: '',
        teacherId: '',
        teacherName: '',

        //课时统计集合
        courseStatisticsList:[],

        //详情集合
        courseDetailsList:[],

        courseStatisticsInfo:{
          id:'',
          teacherId:'',
          takeHours:'',
        },

        checkbox: {
          checkIds: [],
        },

        token: this.$store.state.access_token,
        hrefExport:this.$store.state.serviceBase+"resources/",

        courseInfo:{
          // teacherId:'',
          // teacherName:'',
          startDate:'',
          time:'',
          lessonName:'',
          roomId:'',
          roomName:'',
          takeHours:''
        },
        //上课时间数组
        lesson_time: dictionaryData.lesson_time,
        selfTime: {
          startTime: '',
          endTime: ''
        },
        roomsList:[],
        placeList:[],
        //选择教师步骤
        room_step: 'place',

        isShowRoomDiv : false,
        //教师场所数据集合
        placeList: [],
        //教室集合
        roomsList: [],
        placeId: '',
        roomId: '',
        clazzName: ''
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //日期
        this_.dateDefault();
        this_.initCourseStatisticsListData();
        this_.loadPlace();
        this_.initClassDetails();
        // this_.initCourseDetailsList();

        //绑定加载关闭模态框时的事件
        this_.closeModal();
      });
    },
    methods: {
      /**
       * 课时统计列表
       */
      initCourseStatisticsListData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'teacherLesson/takeHoursStatisticsAllList',
          params: {
            "clazzId":this_.clazzId
          }
        }).then(function (resp) {
          if (resp.data.success) {
            this_.courseStatisticsList = resp.data.list;
          }
        });
      },

      /**
       * 详情
       */
      initCourseDetailsList(teacherId,teacherName){
        let this_=this;
        this_.teacherId = teacherId;
        this_.teacherName = teacherName;
        schoolAxios({
          method: 'get',
          url: 'teacherLesson/takeHoursDetailsListByClazz',
          params: {
            "clazzId":this_.clazzId,
            "teacherId": teacherId,
          }
        }).then(function (response) {
          let data = response.data;
          if (data.success) {
            this_.courseDetailsList = data.list;
          }
        });
      },

      /**
       * 修改课时弹出框
       */
      show_edit(index){
        let this_ = this;
        let my_data = this_.courseDetailsList[index];

        this_.courseStatisticsInfo = {
          id: my_data.id,
          takeHours: my_data.takeHours
        }

        /* $("#myModal").modal("show");*/
      },

      /**
       * 修改课时
       */
      updateClassHour(){
        let this_ = this;
        this_.$validator.validateAll('updateCourse').then(result => {
          if (result) {
            schoolAxios({
              method: 'put',
              url: 'teacherLesson/updateTakeHours',
              data: {
                id: this_.courseStatisticsInfo.id,
                takeHours: this_.courseStatisticsInfo.takeHours,
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                "修改成功".showMessage();
                $("#myModal_update").modal("hide");
                /*$("#myModal").modal("hide");*/
                this_.initCourseStatisticsListData();
                this_.initCourseDetailsList(this_.teacherId);
              }else {
                "修改失败".showMessage();
                $("#myModal_update").modal("hide");
                $("#myModal").modal("hide");
              }
            })
          }
        });
      },
      /**
       * 删除
       */
      deleteCourseDetails(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'teacherLesson/delete/'+id,
            params: {
              // "id":id
              // "lessonId": lessonId,
              // "teacherId": teacherId
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              /*$("#myModal").modal("hide");*/
              this_.initCourseStatisticsListData();
              this_.initCourseDetailsList(this_.teacherId);
            }else{
              "删除失败".showMessage();
              $("#myModal").modal("hide");
            }
          })
        })
      },

      checkedOne (teacherId) {
        let this_ = this;
        let idIndex = this_.checkbox.checkIds.indexOf(teacherId);
        if (idIndex >= 0) {//如果已经包含就去除
          this_.checkbox.checkIds.splice(idIndex, 1);
        } else {//如果没有包含就添加
          this_.checkbox.checkIds.push(teacherId);
        }
      },
      /*全选*/
      checkAll: function (e) {
        let this_ = this;
        let checked = e.target.checked;
        if(checked){
          this_.checkbox.checkIds=[];
          let courseStatisticsList = this_.courseStatisticsList;
          for(let i=0;i<courseStatisticsList.length;i++){
            let idIndex = this_.checkbox.checkIds.indexOf(courseStatisticsList[i].teacherId);
            if (idIndex < 0) {//如果没有包含就添加
              this_.checkbox.checkIds.push(courseStatisticsList[i].teacherId);
            }
          }
        }else{
          this_.checkbox.checkIds=[];
        }
        let element = document.querySelectorAll("input[name=list_item]");
        element.forEach((item) => {
          item.checked = checked;
        });
      },

      /**
       * 导出
       */
      exportCourseStatistics(){
        let this_=this;

        schoolAxios({
          method: 'get',
          url:'teacherLesson/takeHoursExcel',
          params: {
            "clazzId":this_.clazzId,
            "teacherIds":this_.checkbox.checkIds.toString(),
            "access_token":this_.token
          }
        }).then(function (response) {
          if(response.data.success){
            location.href=this_.hrefExport+response.data.data;
          }else {
            (response.data.message||"导出数据失败").showMessage();
          }
        });
      },
      showAddModal(){
        $("#myModal_add").modal("show");
      },
      cancelSaveData(){
        $("#myModal_add").modal("hide");
      },
      /**
       * 查询班级名称
       */
      initClassDetails(){
        let this_=this;
        if(this_.clazzId) {
          schoolAxios({
            method: 'get',
            url: 'clazz/load/' + this_.clazzId,
            params: {}
          }).then(function (response) {
            let data = response.data;
            if (data.success) {
              this_.clazzName = data.data.name;
            }
          });
        }
      },
      addCourseHours(){
        let this_ = this;
        this_.$validator.validateAll('course').then(result => {
          if (result) {
            schoolAxios({
              method: 'put',
              url: 'teacherLesson/add',
              data: {
                clazzId:this_.clazzId,
                clazzName:this_.clazzName,
                teacherId:this_.teacherId,
                teacherName:this_.teacherName,
                startDate: this_.courseInfo.startDate,
                time:this_.courseInfo.time,
                lessonName:this_.courseInfo.lessonName,
                roomId:this_.courseInfo.roomId,
                roomName:this_.courseInfo.roomName,
                takeHours: this_.courseInfo.takeHours,
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                "新增成功".showMessage();
                $("#myModal_add").modal("hide");
                this_.initCourseStatisticsListData();
                this_.initCourseDetailsList(this_.teacherId);
              }else {
                data.message.showMessage();
                $("#myModal_add").modal("hide");
                $("#myModal").modal("hide");
              }
            })
          }
        });
      },
      /**
       * 加载教师场所
       */
      loadPlace(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'place/findList',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.placeList = data.list;
          }
        });
      },
      /**
       * 选择教学场所
       */
      selectPlace(index){
        let this_ = this;
        let my_data = this_.placeList[index];
        this_.courseInfo.roomName = my_data.name+":";
        schoolAxios({
          method: 'get',
          url: 'rooms/findList',
          params: {
            placeId: my_data.id
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.room_step = "rooms";
            this_.roomsList = data.list;
          }
        });
      },
      /**
       * 选择教室
       */
      selectRooms(index){
        let this_ = this;
        let my_data = this_.roomsList[index];

        this_.courseInfo.roomId = my_data.id;
        this_.courseInfo.roomName += my_data.name;

        this_.room_step = "place";
        this_.isShowRoomDiv = false;
      },
      chooseTimeBySelf(){
        let this_ = this;

        $("#myModal_time").modal("show");
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.courseStatisticsInfo = {
            id:'',
            teacherId:'',
            takeHours:''
          }
        });
        $("#myModal_add").on('hide.bs.modal', function () {
          this_.courseInfo={
            // teacherId:'',
            // teacherName:'',
            startDate:'',
            time:'',
            lessonName:'',
            roomId:'',
            roomName:'',
            takeHours:''
          }
          setTimeout(function () {
            this_.errors.clear('course');
          });
        });

      },
      showTimeDiv(){
        $("#time_div").show();
      },
      hideTimeDiv(){
        $("#time_div").hide();
      },
      putTimeData(index){
        let this_ = this;
        if(index >= 0) {
          let data = this_.lesson_time[index];
          this_.courseInfo.time = data;
          $("#time_div").hide();
        }else {
          //this_.new_schedule.time = "";
          $("#time_div").hide();
          $("#myModal_time").modal("show");
        }
      },

      chooseTimeOk(){
        let this_ = this;
        this_.$validator.validateAll('selfTime').then(result => {
          if (result) {
            this_.courseInfo.time = this_.selfTime.startTime + "-" + this_.selfTime.endTime;
            $("#myModal_time").modal("hide");
          }
        });
      },

      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#chooseStartDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseStartDate").val();
          this_.courseInfo.startDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
        /* $('#chooseEndDate').datetimepicker({
           minView: "month",
           language: 'zh-CN',
           format: 'yyyy-mm-dd',
           //startDate: this_.timeDate,
           weekStart: 0,
           todayBtn: true,
           clearBtn: true,
           autoclose: true,
           todayHighlight: true,
           startView: 2,
           forceParse: 0,
           showMeridian: 1,
         }).on('hide', function (ev) {
           let value = $("#chooseEndDate").val();
           this_.courseStatisticsInfo.endDate = value;
           ev.preventDefault();
           ev.stopPropagation();
         });*/
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  .class_body_content {
    top: 10%;
    height: 90%;
  }
  .details_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/workLoad/details_mouseOver.png");
    background-size: 100% 100%;
    margin: 0 0 0 45%;
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
    background-size: 100% 100%;
    cursor: pointer;
    float: left;
    margin: 0 0 0 15px;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete_mouseOver.png");
    background-size: 100% 100%;
    cursor: pointer;
    float: left;
    margin: 0 0 0 20px;
  }
  /*.form-group-div {
    margin-top: 10px;
  }
  .form-group label {
    width: 100px;
  }*/
  .modal-content.modal-work-content {
    width: 900px;
  }
  .modal-content.modal-content-update {
    width: 300px;
    margin: 220px 0 0 300px;
  }
  .table_details tbody{
    height: 300px;
  }
  .table_classStatistics tbody{
    height: 510px;
  }
  input.form-control.scheduleInfo {
    display: inline-block;
    width: 80%;
    margin-top: 10px;
  }
  #time_div {
    position: absolute;
    left: 15%;
    width: 76%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1;
  }
  #time_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #time_div option:hover {
    background-color: grey;
  }
  .room_div {
    position: absolute;
    left: 90px;
    width: 76%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1000;
  }
  .room_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  .room_div option:hover {
    background-color: grey;
  }
  .isShowRoomDivClass {
    display: block;
  }
  #myTab li {
    border: 1px solid black;
    padding: 5px;
    margin: 5px;
    border-radius: 5px;
  }
  #myTab_ li {
    border: 1px solid black;
    padding: 5px;
    margin: 5px;
    border-radius: 5px;
  }
  #myTab li:hover {
    background-color: grey;
  }
  #myTab_ li:hover {
    background-color: #d3ced0;
  }

  .havenClick {
    background-color: grey;
  }
  .searcharea{
    position: absolute;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/courseStatistics.vue